import { DateTime } from "luxon";

export const isDateExpired = (value: unknown): boolean => {
  const parsed = DateTime.fromISO(String(value ?? ""));
  if (!parsed.isValid) return false;

  return parsed.startOf("day") < DateTime.now().startOf("day");
};
